import {Http} from '../../../Data/config/Http';
import {VisitDTO} from '../models/visit.dto';
import {API_ROUTES} from '../../../constants/apiRoutes';
import type {BaseResponse} from '../../../Data/types/BaseResponse';
import {unwrapResponse, handleDataSourceError} from '../../../utils/errorHelpers';

// API Request/Response Interfaces
export interface VisitApprovalRequest {
  visitId: number;
  approved: boolean;
  notes?: string;
}

export interface VisitEditRequest {
  visitId: number;
  notes?: string;
}

/**
 * Minimal response from approve/reject endpoints
 * The API returns only visit_id and status, not the full visit object
 */
export interface VisitActionResponse {
  visit_id: number;
  status: 'pending' | 'approved' | 'rejected';
}

export const VisitAPIDataSourceManagement = {
  // Approve Visit - empty body per Backend V1 contract
  approveVisit: async (visitId: string | number): Promise<VisitActionResponse> => {
    try {
      const response = await Http.put<BaseResponse<VisitActionResponse>>(
        API_ROUTES.VISITS.APPROVE(visitId.toString()),
        {}
      );
      return unwrapResponse(response.data, 'حدث خطأ في الموافقة على الزيارة');
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  // Reject Visit - body { reason } required per Backend V1 contract
  rejectVisit: async (visitId: string | number, reason: string): Promise<VisitActionResponse> => {
    try {
      const response = await Http.put<BaseResponse<VisitActionResponse>>(
        API_ROUTES.VISITS.REJECT(visitId.toString()),
        {reason}
      );
      return unwrapResponse(response.data, 'حدث خطأ في رفض الزيارة');
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  // Edit Visit
  editVisit: async (visitId: string | number, data: VisitEditRequest): Promise<VisitDTO> => {
    try {
      const response = await Http.put<BaseResponse<VisitDTO>>(
        API_ROUTES.VISITS.EDIT(visitId.toString()),
        data
      );
      return unwrapResponse(response.data, 'حدث خطأ في تعديل الزيارة');
    } catch (error) {
      handleDataSourceError(error);
    }
  }
};
